import { render, staticRenderFns } from "./UserModifyPercentModal.vue?vue&type=template&id=0964ec92&"
import script from "./UserModifyPercentModal.vue?vue&type=script&lang=js&"
export * from "./UserModifyPercentModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports